<template>
  <div class="tb-checkbox-grid">
    <b-checkbox v-for="type in gameTypes" :key="type.key" :value="!!value[type.key]" @input="toggle(type.key, $event)">
      {{ type.label }}
    </b-checkbox>
  </div>
</template>

<script>
  import { GAME_TYPES } from "../constants/game";

  /**
   * The list of claims a game can be played for. Shared by "Schedule a game"
   * and "Edit game settings" so the two can never drift apart.
   *
   * Emits a fresh object on every toggle rather than mutating the prop, which
   * also sidesteps Vue 2's inability to react to newly added keys.
   */
  export default {
    name: "GameTypeFields",
    props: {
      value: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return { gameTypes: GAME_TYPES };
    },
    methods: {
      toggle(key, checked) {
        this.$emit("input", { ...this.value, [key]: checked });
      }
    }
  };
</script>
